export default {
    CHANGE_USERNAME(state,String){
        state.uname = String;
    },
    CHANGE_MENU(state,boolean){
          state.isActive = boolean;
    },
    IS_CLOSE(state,boolean){
        state.isClose=boolean;
    },
    //用户按钮
    BTN_0412(state,boolean){
        state.btn_0412=boolean;
    },
    BTN_0413(state,boolean){
        state.btn_0413=boolean;
    },
    BTN_0414(state,boolean){
        state.btn_0414=boolean;
    },
    BTN_0415(state,boolean){
        state.btn_0415=boolean;
    },
    BTN_0416(state,boolean){
        state.btn_0416=boolean;
    },
    BTN_0417(state,boolean){
        state.btn_0417=boolean;
    },
    // BTN_All(state,btnlist){
    //     state.btnlist=btnlist
    //     for (let i = 0,len = state.btnlist.length; i < len; i++) {
    //         //debugger
    //
    //         //onsole.log(state);
    //         // if (state.btnlist[i].id == orderPsg.id) {
    //         //
    //         //     //state.orderPsgList.splice(i,1)
    //         //     return;
    //         // }
    //     }
    // }
}




// WEBPACK FOOTER //
// ./src/store/mutations.js